import CompartmentUsageDetails from './CompartmentUsageDetails';

export default CompartmentUsageDetails;
